import { Checkbox } from '@/components/ui/checkbox';
import { SharedAgency } from '@/types/distributors/agencySelectionColumnDef';
import { Row } from '@tanstack/react-table';
import { useState } from 'react';

const AgencyRowCheckbox = ({ row }: { row: Row<SharedAgency> }) => {
  const [isChecked, setIsChecked] = useState<'indeterminate' | boolean>(
    row.original.someCircuitsAreShared
      ? !row.original.allCircuitsAreShared && 'indeterminate'
      : false,
  );

  return (
    <Checkbox
      checked={row.getIsSelected() || isChecked}
      onCheckedChange={(value) => {
        setIsChecked(false);
        row.toggleSelected(!!value);
      }}
      aria-label="Select row"
    />
  );
};

export default AgencyRowCheckbox;
